import { Dropdown, Menu } from "antd";
import { DownOutlined } from "@ant-design/icons";
import useLanguageStore, { Language } from "../stores/languageStore.ts";

const languages: { code: Language; label: string; flag: string }[] = [
    { code: "en", label: "English", flag: "🇬🇧" },
    { code: "vn", label: "Tiếng Việt", flag: "🇻🇳" },
];

export default function LanguageSwitcher() {
    const { currentLanguage, setLanguage } = useLanguageStore();

    const handleClick = ({ key }: { key: string }) => {
        setLanguage(key as Language);
    };

    const menu = (
        <Menu onClick={handleClick} selectedKeys={[currentLanguage]} items={languages.map((l) => ({ key: l.code, label: `${l.flag} ${l.label}` }))} />
    );

    const current = languages.find((l) => l.code === currentLanguage);

    return (
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
            <button className="flex items-center gap-2 p-2 hover:bg-yellow-50 rounded-xl transition-colors">
                <span>{current?.flag}</span>
                <DownOutlined />
            </button>
        </Dropdown>
    );
}
